import React, { useEffect, useState } from 'react';
import { Col, Row, Button, DatePicker, Empty, Pagination, Space } from 'antd';
import Wrapper from '../../../components/Wrapper';
import Select from '../../../components/FormElements/Select';
import TaskCard from '../../../components/Cards/TaskCard';
import { Select as ObjSelect } from 'antd';
import {
  FoundWorks,
  ResultsContent,
  FilterContainer,
  SearchInput,
} from './style';
import works from '../../../services/works';
import { NoData } from '../../Supervisor/style';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { workConstructor } from '../../../utils/workConstructor';
import Spinner from '../../../components/Spinner';
import objects from '../../../services/objects';
import { Input } from 'antd';
import { useShowAlert } from '../../../hooks';
import { useMemo } from 'react';
import organizationService from '../../../services/organization';
import RatedWork from '../../../components/Cards/TaskCard';
import { FiSearch } from 'react-icons/fi';
import { Title } from '../../../components/FormElements/Select/style';
const { RangePicker } = DatePicker;

export default () => {
  var today = moment();
  let startDate = moment().format('YYYY-MM-DD');
  var yesterday = moment(today).subtract(1, 'days').format('YYYY-MM-DD');
  const { Option } = ObjSelect;

  const { categories, regions, groups, users } = useSelector(
    (state) => state.appReducer
  );
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const [mustBeSelect, setMustBeSelect] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [worksData, setWorksData] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [objectList, setObjectList] = useState([]);
  const [organizationList, setOrganizationList] = useState([]);
  const [objectSubList, setObjectSubList] = useState([]);
  const [postData, setPostData] = useState({
    startDate: moment(yesterday).format('YYYY-MM-DD'),
    endDate: moment(startDate).format('YYYY-MM-DD'),
  });
  const [pageNum, setPageNum] = useState(1);

  const { constructorMethod } = workConstructor();
  const [search, setSearch] = useState('');
  const [worksTotal, setWorksTotal] = useState(0);
  const [attendeds, setAttendeds] = useState(0);

  const fetchObjects = () => {
    objects
      .getAll()
      .then((resp) => setObjectList(resp))
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    const categoryAll = categories.filter((c) => c.parent === null);
    setCategoryList(categoryAll);
    if (worksData.length > 0) fetchWorks();
  }, [pageNum, categories, regions, groups, users, pageSize]);

  useEffect(() => {
    fetchObjects();
    organizationService
      .getAll({ page: 1, limit: 1000 })
      .then((resp) => {
        setOrganizationList(resp?.docs);
      })
      .catch((err) => console.error(err));
  }, [categories, regions, groups, users]);

  const filteredSubObjects = useMemo(() => {
    const data = {
      parent: postData?.parentObjects,
    };
    if (postData?.region) {
      data['region'] = postData?.region;
    }
    if (postData?.group) {
      data['group'] = postData?.group;
    }
    return data;
  }, [postData?.region, postData?.group, postData?.parentObjects]);
  useEffect(() => {
    if (postData?.parentObjects) {
      objects
        .getAllSubsList(filteredSubObjects)
        .then((subsList) => {
          setObjectSubList(subsList);
        })
        .catch((err) => console.error(err));
    }
  }, [filteredSubObjects]);
  const handleSubCategory = (value) => {
    const subCategoryData = categories.filter((item) => item.parent === value);
    setSubCategoryList(subCategoryData);
  };
  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const onShowSizeChange = (_, pageSize) => {
    setPageSize(pageSize);
  };

  const handleObject = (value) => {
    const objectId = categories.find((item) => item._id === value);
    if (objectId?.object) {
      const filteredObjects = objectList.filter(
        (item) => item._id === objectId?.object
      );
      setObjectList(filteredObjects);
    }
  };
  const handleGetSubObjects = (val) => {
    if (!postData?.region) {
      setMustBeSelect(true);
    }
    if (val === undefined) {
      fetchObjects();
      setMustBeSelect(false);
    }
  };
  const handleChangeRangePicker = (_, value) => {
    postData.startDate = value[0];
    postData.endDate = value[1];
  };
  const fetchWorks = () => {
    if (search.length > 0 || Object.keys(postData).length > 0) {
      const common = { categories, regions, groups, users };
      setLoading(true);
      const data = {
        page: pageNum,
        limit: pageSize,
        status: 3,
        ...postData,
      };
      if (search?.length > 0) {
        data['search'] = search;
      }
      if (postData?.objects !== undefined) {
        data['objects'] = postData?.objects.split(' ');
      }
      works
        .getAll(data)
        .then(({ docs, totalDocs, attendeds }) => {
          setWorksTotal(totalDocs);
          setAttendeds(attendeds);
          const workerData = constructorMethod(docs, common);
          setWorksData(workerData);
        })
        .finally(() => setLoading(false))
        .catch((err) => console.error(err));
    } else {
      error('Илтимос қидириш учун аввал майдонларни тўлдиринг', 2, 'topRight');
    }
  };

  if (loading) return <Spinner maxHeight='100%' />;
  return (
    <Wrapper>
      <FilterContainer>
        <Row gutter={[10, 30]} align='middle' justify='space-between'>
          <Col span={12}>
            {[10, 20, 50, 100].map((btn) => (
              <Button
                type={pageSize.toString() === btn.toString() ? 'primary' : ''}
                key={btn}
                style={{
                  borderRadius: '5px',
                  marginRight: '10px',
                  background: `${
                    pageSize.toString() === btn.toString() ? '#3380FF' : '#fff'
                  }`,
                }}
                onClick={() => {
                  setPageNum(1);
                  setPageSize(btn);
                }}
              >
                {btn}
              </Button>
            ))}
          </Col>
          <Col>
            <Row gutter={10} align='middle'>
              <Col>Даврни танлаш</Col>
              <Col>
                <RangePicker
                  allowClear={false}
                  onChange={handleChangeRangePicker}
                  defaultValue={[
                    moment(postData?.startDate),
                    moment(postData?.endDate),
                  ]}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row gutter={[10, 20]} align='bottom'>
          <Col span={5}>
            <Select
              status={mustBeSelect ? 'error' : ''}
              handleChange={(value) => {
                setPostData({ ...postData, ['region']: value });
                setMustBeSelect(false);
              }}
              options={regions}
              name='region'
              defaultVal={postData?.region}
              title='Шаҳар(туман)'
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) =>
                setPostData({ ...postData, ['group']: value })
              }
              name='group'
              options={groups}
              defaultVal={postData?.group}
              title='Гуруҳ'
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) =>
                setPostData({ ...postData, ['organization']: value })
              }
              name='organization'
              options={organizationList}
              defaultVal={postData?.organization}
              title='Ташкилотлар'
            />
          </Col>

          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['category']: value });
                handleSubCategory(value);
              }}
              options={categoryList}
              name='category'
              title='Асосий категориялар'
              defaultVal={postData?.category}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['subCategory']: value });
                handleObject(value);
              }}
              options={subCategoryList}
              name='subCategory'
              title='Суб категориялар'
              defaultVal={postData?.subCategory}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) => {
                setPostData({ ...postData, ['parentObjects']: value });
                handleGetSubObjects(value);
              }}
              options={objectList}
              name='parentObjects'
              title='Асосий обектлар'
              defaultVal={postData?.parentObjects}
            />
          </Col>
          <Col span={5}>
            <Select
              handleChange={(value) =>
                setPostData({ ...postData, ['objects']: value })
              }
              options={objectSubList}
              name='objects'
              title='Суб обектлар'
              disabled={mustBeSelect}
              objSelect={true}
              defaultVal={postData?.objects}
            />
          </Col>
          <Col
            span={8}
            style={{
              display: 'flex',
              gap: '20px',
              alignItems: 'flex-end',
            }}
          >
            <SearchInput>
              <Title level={5}>Қидирув</Title>
              <Input
                placeholder='Матн бўйича қидирув...'
                allowClear
                prefix={<FiSearch color='#CCCCCC' size={12} />}
                className='search'
                style={{
                  background: '#FFFFFF',
                  border: '1px solid rgba(0, 0, 0, 0.07)',
                  borderRadius: '10px',
                  height: '42px',
                  fontSize: '14px',
                  minWidth: '160px',
                }}
                onChange={handleSearch}
                value={search}
              />
            </SearchInput>
            <Button
              type='primary'
              onClick={fetchWorks}
              style={{
                height: '40px',
                background: '#3380FF',
                borderRadius: '10px',
                padding: '0 40px',
              }}
            >
              Қидириш
            </Button>
          </Col>
        </Row>
      </FilterContainer>
      {worksData.length > 0 ? (
        <Row justify='space-between'>
          <Col>
            <Space style={{ fontSize: '20px', fontWeight: 'bold' }}>
              Қидирув бўйича топилган ишлар сони: {worksTotal}
            </Space>
          </Col>
          <Col>
            <Space style={{ fontSize: '20px', fontWeight: 'bold' }}>
              Барча қатнашчилар сони: {attendeds}
            </Space>
          </Col>
        </Row>
      ) : null}
      <ResultsContent noBorder={worksData.length > 0 && true}>
        {worksData.length > 0 ? (
          <>
            {worksData.map((work, indx) => (
              // {worksData.map((work, indx) => (
              <FoundWorks key={`${indx + 1}`}>
                <RatedWork
                  medium
                  data={work}
                  noCheckLIst
                  readOnlyFooter
                  searchText={search}
                />
              </FoundWorks>
            ))}
            {worksTotal > 10 && worksTotal >= pageSize && (
              <div className='pagination-footer'>
                <Pagination
                  current={pageNum}
                  pageSize={pageSize}
                  onShowSizeChange={onShowSizeChange}
                  total={worksTotal}
                  onChange={(page) => setPageNum(page)}
                />
              </div>
            )}
          </>
        ) : (
          <NoData>
            <Empty
              description={
                <h1>Белгиланган кун учун қилинган ишлар топилмади!</h1>
              }
            />
          </NoData>
        )}
      </ResultsContent>
    </Wrapper>
  );
};
